/* eslint-disable react/no-array-index-key */
import { navigate } from "gatsby";
import React from "react";
import LearningCenterGridContainer from "../../components/Molecules/LearningCenterGridContainer";

const genLearningCenterComponents = ({recommendedArticlesProps, pageContext, isContractedVariation}) => ({
    gridContainerComp: recommendedArticlesProps.map((grid, index) =>
    {
        const newContext = isContractedVariation ? {
            ...pageContext,
            totalPosts: grid?.articleListProps?.queryArgs?.posts?.length || 0,
        } : pageContext;
        return (<LearningCenterGridContainer
            key={`learning-center-related-grid-${index}`}
            {...grid}
            pageContext={newContext}
            isContractedVariation={isContractedVariation}
        />)
    })
});

export const getRelatedPost = (sortedRelatedPosts, featuredArticle) => sortedRelatedPosts
    .filter(post => post?.node?.databaseId !== featuredArticle?.node?.databaseId);

export const handlePageChange = (uri) => (selectedPage) =>
{
    const pageNumber = selectedPage + 1;
    const url = pageNumber === 1 ? `${uri}` : `${uri.replace(/\/$/gm, '')}/page/${pageNumber}`;
    navigate(url);
}

export default genLearningCenterComponents;
